import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './i18n';

import Full from './layouts/Full';
import UserLayout from './layouts/UserLayout';
import AdminLayout from './layouts/AdminLayout';

import Login from './page/Auth/Login';
import Logout from './page/Auth/Logout';
import Register from './page/Auth/Register';
import ForgotPassword from './page/Auth/ForgotPassword';
import AccountActivated from './page/Auth/AccountActivated';
import ChangePassword from './page/Auth/ChangePassword';

// ---------- Admin -------------

import Setting from './page/Admin/Setting/Setting';
import EmailSetting from './page/Admin/Setting/EmailSetting';
import CommonSetting from './page/Admin/Setting/CommonSetting';
import InvoiceSetting from './page/Admin/Setting/InvoiceSetting';
import ExcludingDomainsSetting from './page/Admin/Setting/ExcludingDomainsSetting';

import AdminDashboard from './page/Admin/Dashboard';

import UserRolesList from './page/Admin/UserRoles/UserRolesList';
import UserRoles from './page/Admin/UserRoles/UserRoles';

import AdminUserList from './page/Admin/AdminUser/UserList';
import AdminUser from './page/Admin/AdminUser/User';

import UserList from './page/Admin/User/UserList';
import UserView from './page/Admin/User/View';

import SubscriptionPlanList from './page/Admin/SubscriptionPlan/SubscriptionPlanList';
import SubscriptionPlan from './page/Admin/SubscriptionPlan/SubscriptionPlan';

import BanksList from './page/Admin/Bank/BanksList';
import Banks from './page/Admin/Bank/Bank';

import ChequeFormatList from './page/Admin/ChequeFormat/ChequeFormatList';
import ChequeFormat from './page/Admin/ChequeFormat/ChequeFormat';

import AdminInvoicesList from './page/Admin/Invoice/InvoicesList';
import AdminOrderList from './page/Admin/Order/OrderList';
import SubscriptionList from './page/Admin/Invoice/SubscriptionList';

import EnquiryList from './page/Admin/Enquiry/EnquiryList';



// ---------- User -----------
import Dashboard from './page/User/Dashboard';

import MyProfileSetting from './page/User/Setting/MyProfile';
import Support from './page/User/Setting/Support';

import InvoicesList from './page/User/Invoice/InvoicesList';
import ChequeIssuedList from './page/User/ChequeIssued/ChequeIssuedList';
import ChequeIssuedForm from './page/User/ChequeIssued/ChequeIssuedForm';
import ChequePreview from './page/Preview/ChequePreview';
import ChequeSettingForm from './page/User/Setting/ChequeSettingForm';



// import Url from './page/Url/Url';

function App() {
    const router = createBrowserRouter([
        {
            path: "/",
            element: <Full />,
            children: [
                {
                    path: "",
                    element: <Login />,
                },
                {
                    path: "signup",
                    element: <Register />,
                },
                {
                    path: "account-activated/:id",
                    element: <AccountActivated />,
                },
                {
                    path: "/forgot",
                    element: <ForgotPassword />,
                },
                {
                    path: "/logout",
                    element: <Logout />,
                },
                {
                    path: "/preview",
                    element: <ChequePreview />,
                },

            ],
        },
        {
            path: "/",
            element: <UserLayout />,
            children: [
                {
                    path: "dashboard",
                    element: <Dashboard />,
                },
                {
                    path: "change-password",
                    element: <ChangePassword />,
                },
                {
                    path: "cheque-issued",
                    children: [
                        {
                            path: "",
                            element: <ChequeIssuedList />,
                        },
                        {
                            path: "add",
                            element: <ChequeIssuedForm />,
                        },
                        {
                            path: "edit/:id",
                            element: <ChequeIssuedForm />,
                        }
                    ]
                },
                {
                    path: "invoices",
                    children: [
                        {
                            path: "",
                            element: <InvoicesList />,
                        }
                    ]
                },
                {
                    path: "/",
                    children: [
                        {
                            path: "profile",
                            element: <MyProfileSetting />,
                        },
                        {
                            path: "support",
                            element: <Support />,
                        },
                        {
                            path: "setting",
                            element: <ChequeSettingForm />,
                        }
                    ]
                },

            ],
        }, {
            path: "/admin",
            element: <AdminLayout />,
            children: [
                {
                    path: "dashboard",
                    element: <AdminDashboard />,
                },
                {
                    path: "change-password",
                    element: <ChangePassword />,
                },
                {
                    path: "setting",
                    children: [
                        {
                            path: "",
                            element: <Setting />,
                        },
                        {
                            path: "email",
                            element: <EmailSetting />,
                        },
                        {
                            path: "common",
                            element: <CommonSetting />,
                        },
                        {
                            path: "invoice",
                            element: <InvoiceSetting />,
                        },
                        {
                            path: "excluding-domains",
                            element: <ExcludingDomainsSetting />,
                        },
                    ]
                },
                {
                    path: "user-roles",
                    children: [
                        {
                            path: "",
                            element: <UserRolesList />,
                        },
                        {
                            path: "add",
                            element: <UserRoles />,
                        },
                        {
                            path: "edit/:id",
                            element: <UserRoles />,
                        }
                    ]
                },
                {
                    path: "admin-users",
                    children: [
                        {
                            path: "",
                            element: <AdminUserList />,
                        },
                        {
                            path: "add",
                            element: <AdminUser />,
                        },
                        {
                            path: "edit/:id",
                            element: <AdminUser />,
                        }
                    ]
                },
                {
                    path: "users",
                    children: [
                        {
                            path: "",
                            element: <UserList />,
                        },
                        {
                            path: "view/:id",
                            element: <UserView />,
                        }
                    ]
                },
                {
                    path: "banks",
                    children: [
                        {
                            path: "",
                            element: <BanksList />,
                        },
                        {
                            path: "add",
                            element: <Banks />,
                        },
                        {
                            path: "edit/:id",
                            element: <Banks />,
                        }
                    ]
                },
                {
                    path: "cheque-formates",
                    children: [
                        {
                            path: "",
                            element: <ChequeFormatList />,
                        },
                        {
                            path: "add",
                            element: <ChequeFormat />,
                        },
                        {
                            path: "edit/:id",
                            element: <ChequeFormat />,
                        }
                    ]
                },
                {
                    path: "subscription-plan",
                    children: [
                        {
                            path: "",
                            element: <SubscriptionPlanList />,
                        },
                        {
                            path: "add",
                            element: <SubscriptionPlan />,
                        },
                        {
                            path: "edit/:id",
                            element: <SubscriptionPlan />,
                        }
                    ]
                },
                {
                    path: "subscription",
                    children: [
                        {
                            path: "",
                            element: <SubscriptionList />,
                        }
                    ]
                },
                {
                    path: "invoices",
                    children: [
                        {
                            path: "",
                            element: <AdminInvoicesList />,
                        }
                    ]
                },
                {
                    path: "orders",
                    children: [
                        {
                            path: "",
                            element: <AdminOrderList />,
                        }
                    ]
                },
                {
                    path: "enquiries",
                    children: [
                        {
                            path: "",
                            element: <EnquiryList />,
                        }
                    ]
                }

            ]
        }

    ])

    useEffect(() => {
        const checkVersion = async () => {
            try {
                const res = await fetch('/version.json', { cache: 'no-store' });
                const data = await res.json();
                const storedVersion = localStorage.getItem("app_version");
                if (data.version !== storedVersion) {
                    localStorage.setItem("app_version", data.version);
                    window.location.reload(true);
                }
            } catch (error) {
                console.error("Version check failed:", error);
            }
        };

        checkVersion(); // Run on load

        const interval = setInterval(checkVersion, 5 * 60 * 1000); // Every 5 minutes

        return () => clearInterval(interval);
    }, []);

    return (
        <RouterProvider router={router} />
    );
}

export default App;